module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-verde style=margin-bottom:40px>Nombre ya existe.</h3> </div> </div> <div class=\"row text-right\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=finalize()>Cerrar</md-button> </div> </div> </md-dialog-content> </md-dialog>";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/report/list/modalMsjNameReport.html
// module id = 351
// module chunks = 0